'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ExportService = exports.ExportService = function () {
    function ExportService(winresCloudService) {
        _classCallCheck(this, ExportService);

        this.winresCloudService = winresCloudService;
    }

    _createClass(ExportService, [{
        key: 'exportPdfFragment',
        value: function exportPdfFragment(htmlFragment, filename) {
            // Collect CSS from the page.
            var html = '<html><head><meta charset="utf-8"></meta><title>' + filename + '</title>';

            $('link[rel="stylesheet"]').each(function () {
                if ($(this).attr('media') === 'screen') {
                    return;
                }
                var href = $(this).attr('href');
                html += '<link rel="stylesheet" href="' + href + '" media="all" />';
            });
            $('style').each(function () {
                html += '<style>' + $(this).html() + '</style>';
            });
            html += '</head><body>' + htmlFragment + '</body></html>';

            return this.exportPdf(html, filename);
        }
    }, {
        key: 'exportPdf',
        value: function exportPdf(html, filename) {
            var _this = this;

            return this.winresCloudService.makeAuthenticatedRequest('ExportPdf', {
                Html: html,
                Filename: filename
            },
            /*withOverlay=*/true,
            /*responseType=*/'blob').then(function (blob) {
                if (blob) {
                    _this.downloadFile(blob, filename);
                }
            });
        }

        // spreadsheet: 
        // [
        //   [
        //     { Bold: true, Data: 'Etunimi', Type: 'Text' },
        //     { Bold: true, Data: 'Sukunimi', Type: 'Text' }
        //     { Bold: true, Data: 'Summa', Type: 'Text' }
        //   ],
        //   [
        //     { Data: 'Pertti', Type: 'Text' },
        //     { Data: 'Virtanen', Type: 'Text' }
        //     { Data: 10, Type: 'Number' }
        //   ]
        // ];

    }, {
        key: 'exportExcel',
        value: function exportExcel(spreadsheet, filename) {
            var _this2 = this;

            return this.winresCloudService.makeAuthenticatedRequest('ExportExcel', {
                Spreadsheet: spreadsheet,
                Filename: filename
            },
            /*withOverlay=*/true,
            /*responseType=*/'blob').then(function (blob) {
                if (blob) {
                    _this2.downloadFile(blob, filename);
                }
            });
        }
    }, {
        key: 'downloadFile',
        value: function downloadFile(blob, filename) {
            var url = window.URL.createObjectURL(blob);
            var a = $('<a>').attr('href', url).attr('download', filename);
            $('body').append(a);
            a[0].click();
            window.URL.revokeObjectURL(url);
            $(a).remove();
        }
    }]);

    return ExportService;
}();

ExportService.$inject = ['winresCloudService'];


//////////////////
// WEBPACK FOOTER
// ./src/winresCloud/exportService.js
// module id = 567
// module chunks = 2